import { roundUpTo } from 'functions/roundUpTo';
import { CalculatedNutrient } from 'types/NutrientValue/CalculatedNutrientValues';
import Style from 'types/_general/Style';

interface IProps {
	nutrient: CalculatedNutrient;
	sourceLeft: string;
	sourceRight: string;
	valueLeft: number | null;
	valueRight: number | null;
}

const roundingDigits: number = 2;

const ErpNutrientTableRow = ({
	nutrient,
	sourceLeft,
	sourceRight,
	valueLeft,
	valueRight,
}: IProps) => {
	if (valueLeft === null && valueRight === null) return <></>;
	return (
		<tr>
			<td>
				{`${nutrient.nutrient} `}
				<span className="nutrient-table-unit">{`(${nutrient.unit})`}</span>
			</td>
			<td className="text-end no-wrap" style={style.td}>
				{sourceLeft}
			</td>
			<td className="text-end no-wrap" style={style.td} title={String(valueLeft)}>
				{valueLeft !== null ? roundUpTo(valueLeft, roundingDigits) : '–'}
			</td>
			<td className="text-end no-wrap" style={style.td}>
				{sourceRight}
			</td>
			<td className="text-end no-wrap" style={style.td} title={String(valueRight)}>
				{valueRight !== null ? roundUpTo(valueRight, roundingDigits) : '–'}
			</td>
		</tr>
	);
};

const style: Style = {
	td: {
		width: '85px',
		minWidth: '85px',
	},
};

export default ErpNutrientTableRow;
